module.exports = __webpack_public_path__ + "img/marcas-todos-los-productos.751843a3.png";